import React, { ReactElement, useState, CSSProperties } from "react";
import { useHistory } from "react-router-dom";
import OnboardingCard from "../OnboardingCard/OnboardingCard";
import Button from "../Button/Button";
import styles from "./OnboardingGroup.module.css";

export interface OnboardingItem {
  heading: string;
  imgSrc: string;
  paragraphs: Array<string | ReactElement>; //string[];
}

interface OnboardingGroupProps {
  cards: OnboardingItem[];
  linkTo?: string;
  onDone?: () => void;
  doneBtnText?: string;
  prevBtnText?: string;
  nextBtnText?: string;
  dotsType?: string;
  cardsWrapperStyle?: CSSProperties;
  cardsImgStyle?: CSSProperties;
  cardsHeadingStyle?: CSSProperties;
  cardsParagraphStyle?: CSSProperties;
  prevBtnStyle?: CSSProperties;
  noPrevBtnStyle?: CSSProperties;
  nextBtnStyle?: CSSProperties;
}

export const OnboardingGroup: React.FC<OnboardingGroupProps> = ({
  cards,
  linkTo = "/",
  onDone,
  doneBtnText = "Get started",
  prevBtnText = "Prev",
  nextBtnText = "Next",
  dotsType = "circle",
  cardsWrapperStyle,
  cardsImgStyle,
  cardsHeadingStyle,
  cardsParagraphStyle,
  prevBtnStyle,
  noPrevBtnStyle,
  nextBtnStyle,
}): ReactElement => {
  const [currentCard, setCurrentCard] = useState(0);
  const history = useHistory();

  const prevCard = () => {
    setCurrentCard(currentCard - 1);
  };

  const nextCard = () => {
    setCurrentCard(currentCard + 1);
  };

  const getStarted = () => {
    if (onDone) {
      onDone();
    } else {
      history.push(linkTo);
    }
  };

  const { heading, imgSrc, paragraphs } = cards[currentCard];
  return (
    <>
      <OnboardingCard
        heading={heading}
        imgSrc={imgSrc}
        paragraphs={paragraphs}
        wrapperStyle={cardsWrapperStyle}
        imgStyle={cardsImgStyle}
        headingStyle={cardsHeadingStyle}
        paragraphStyle={cardsParagraphStyle}
      />
      <div className={styles.row}>
        {currentCard !== 0 ? (
          <Button
            name="prev"
            text={prevBtnText}
            color="blue"
            onClick={prevCard}
            style={{ margin: "0 30px", ...prevBtnStyle }}
          />
        ) : (
          <div style={{ width: "73px", margin: "0 30px", ...noPrevBtnStyle }} />
        )}
        <div className={styles.dot_group} style={{ visibility: cards.length === 1 ? "hidden" : "visible" }}>
          {cards.map((_, index) => (
            <div
              role="button"
              onClick={() => {
                setCurrentCard(index);
              }}
              onKeyPress={(e) => e.key === "Enter" && setCurrentCard(index)}
              tabIndex={currentCard === index ? -1 : 0}
              key={index}
              className={`${dotsType === "circle" ? styles.circle_dot : styles.line_dot} ${
                index === currentCard ? styles.active : ""
              }`}
            >
              {index + 1 + "/" + cards.length}
            </div>
          ))}
        </div>
        {currentCard !== cards.length - 1 ? (
          <Button
            name="next"
            text={nextBtnText}
            color="blue"
            onClick={nextCard}
            style={{ margin: "0 30px", ...nextBtnStyle }}
          />
        ) : (
          <Button name="get started" text={doneBtnText} color="blue" onClick={getStarted} style={nextBtnStyle} />
        )}
      </div>
    </>
  );
};
